import { useCallback, useEffect, useState } from "react";
import styles from "./market.module.css";

// What Extensions, the Store, School, Lessons and Customize share: asking the server, and a few plain parts.
export async function ask(path, { method = "GET", body, signal } = {}) {
  const response = await fetch(`/api/${path}`, { method, signal, cache: "no-store", credentials: "same-origin", ...(body !== undefined ? { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) } : {}) });
  let payload;
  try { payload = await response.json(); } catch { throw new Error("Couldn't reach TrueChops. Please try again."); }
  if (!response.ok) throw Object.assign(new Error(payload.error || "Please try again."), { status: response.status });
  return payload;
}
export function useAsk(path) {
  const [state, setState] = useState({ data: null, error: "", pending: Boolean(path) }), [turn, setTurn] = useState(0);
  useEffect(() => {
    if (!path) { setState({ data: null, error: "", pending: false }); return undefined; }
    const abort = new AbortController();
    setState((current) => ({ ...current, pending: true }));
    ask(path, { signal: abort.signal }).then((data) => { if (!abort.signal.aborted) setState({ data, error: "", pending: false }); })
      .catch((error) => { if (!abort.signal.aborted) setState({ data: null, error: error.message, pending: false }); });
    return () => abort.abort();
  }, [path, turn]);
  return { ...state, refresh: useCallback(() => setTurn((value) => value + 1), []) };
}
// Runs something that talks to the server: `busy` while it does, `error` if it fails.
export function useAction() {
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const run = useCallback(async (fn) => {
    setBusy(true); setError("");
    try { return await fn(); } catch (failure) { setError(failure.message || "That didn't work."); return null; } finally { setBusy(false); }
  }, []);
  return { busy, error, run, setError };
}

export const Badge = ({ kind = "plain", children, title }) => <span className={styles.badge} data-kind={kind} title={title}>{children}</span>;
export const Field = ({ label, hint, children }) => <label className={styles.field}><span>{label}</span>{children}{hint && <small>{hint}</small>}</label>;
export const Problem = ({ children }) => children ? <p className={styles.problem} role="alert">{children}</p> : null;
export const Note = ({ children }) => <p className={styles.note}>{children}</p>;
export const Loading = ({ children = "Loading…" }) => <p className={styles.note} role="status">{children}</p>;
export const shortDate = (value) => value ? new Date(value).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "";
export const dateAndTime = (value) => value ? new Date(value).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
// A value for <input type="datetime-local">, in the browser's own time.
export const forDateInput = (value) => { if (!value) return ""; const date = new Date(value); return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16); };
export const money = (cents, currency = "usd") => cents ? (cents / 100).toLocaleString("en-US", { style: "currency", currency: currency.toUpperCase() }) : "Free";
